export const CAMPAIGNDETAIL_LOADING = "CAMPAIGNDETAIL_LOADING";
export const CAMPAIGNDETAIL_RESET = "CAMPAIGNDETAIL_RESET";
export const GET_CAMPAIGNDETAIL = "GET_CAMPAIGNDETAIL";
export const GET_CAMPAIGNDETAIL_SUCCESS = "GET_CAMPAIGNDETAIL_SUCCESS";
export const GET_CAMPAIGNDETAIL_FAIL = "GET_CAMPAIGNDETAIL_FAIL";
export const DELETE_CAMPAIGNDETAIL = "DELETE_CAMPAIGNDETAIL"
export const DELETE_CAMPAIGNDETAIL_SUCCESS = "DELETE_CAMPAIGNDETAIL_SUCCESS"
export const DELETE_CAMPAIGNDETAIL_FAIL = "DELETE_CAMPAIGNDETAIL_FAIL"
export const UPDATE_CAMPAIGNDETAIL = "UPDATE_CAMPAIGNDETAIL"
export const UPDATE_CAMPAIGNDETAIL_SUCCESS = "UPDATE_CAMPAIGNDETAIL_SUCCESS"
export const UPDATE_CAMPAIGNDETAIL_FAIL = "UPDATE_CAMPAIGNDETAIL_FAIL"
export const ADD_NEW_CAMPAIGNDETAIL = "ADD_NEW_CAMPAIGNDETAIL"
export const ADD_CAMPAIGNDETAIL_SUCCESS = "ADD_CAMPAIGNDETAIL_SUCCESS"
export const ADD_CAMPAIGNDETAIL_FAIL = "ADD_CAMPAIGNDETAIL_FAIL"